/**
 * @generated SignedSource<<4810fee6f5140d8bfc956d59d8613ccf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductTaskState = "CANCELLED" | "COMPLETED" | "ERROR" | "PARTIAL_SUCCESS" | "PROCESSING" | "WAITING";
export type productDuplicationTaskQueriesRestartMutation$variables = {
  taskId: number;
};
export type productDuplicationTaskQueriesRestartMutation$data = {
  readonly restartProductTask: {
    readonly createdOn: string;
    readonly id: string;
    readonly modifiedOn: string;
    readonly progress: {
      readonly completedOperations: number;
      readonly overallProgress: number;
      readonly totalOperations: number;
    } | null;
    readonly settings: {
      readonly assignPricingRules: boolean;
      readonly cloneBulkVariationForm: boolean | null;
      readonly cloneTemplates: boolean | null;
      readonly destinationProductIds: ReadonlyArray<string>;
      readonly salesChannelId: number | null;
      readonly sellerID: number;
      readonly sourceProductId: string;
      readonly userID: number | null;
    } | null;
    readonly status: number;
    readonly taskID: number;
    readonly taskState: ProductTaskState;
    readonly type: string;
  } | null;
};
export type productDuplicationTaskQueriesRestartMutation = {
  response: productDuplicationTaskQueriesRestartMutation$data;
  variables: productDuplicationTaskQueriesRestartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskId",
        "variableName": "taskId"
      }
    ],
    "concreteType": "ProductTaskDto",
    "kind": "LinkedField",
    "name": "restartProductTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modifiedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskSettingsDto",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceProductId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "destinationProductIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloneTemplates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloneBulkVariationForm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignPricingRules",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salesChannelId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sellerID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskProgressDto",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overallProgress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productDuplicationTaskQueriesRestartMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productDuplicationTaskQueriesRestartMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "e03a7e507a9d94c3d3b8d474adcddd2e",
    "id": null,
    "metadata": {},
    "name": "productDuplicationTaskQueriesRestartMutation",
    "operationKind": "mutation",
    "text": "mutation productDuplicationTaskQueriesRestartMutation(\n  $taskId: Long!\n) {\n  restartProductTask(taskId: $taskId) {\n    id\n    taskID\n    type\n    status\n    taskState\n    createdOn\n    modifiedOn\n    settings {\n      sourceProductId\n      destinationProductIds\n      cloneTemplates\n      cloneBulkVariationForm\n      assignPricingRules\n      salesChannelId\n      sellerID\n      userID\n    }\n    progress {\n      totalOperations\n      completedOperations\n      overallProgress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6790d78fae66d15f7a58cdd675934e9d";

export default node;
